import axios from "axios";
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAIL,
} from "../constants/AuthConstants";
import AuthService from "../services/AuthService";

export const loginUser = (serviceNo, password) => async (dispatch) => {
  dispatch({
    type: LOGIN_REQUEST,
  });

  return await AuthService.LoginUser(serviceNo, password).then(
    (data) => {
      if (data.data.StatusCode === 200 && data.data.AuthKey) {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: {
            authKey: data.data.AuthKey,
            message: data.data.Message || "Login successful",
          },
        });
        // Set auth-key header immediately
        axios.defaults.headers.common["auth-key"] = data.data.AuthKey;
        
        // Small delay to ensure header is applied before making next request
        setTimeout(() => {
          dispatch(fetchUserDetails(serviceNo));
        }, 100);
      } else if (data.data.StatusCode === 404 || !data.data.AuthKey) {
        dispatch({
          type: LOGIN_FAIL,
          payload: {
            msg: "Invalid service number or password. Please try again.",
          },
        });
      } else {
        dispatch({
          type: LOGIN_FAIL,
          payload: {
            msg: data.data.Message || "Login failed. Please try again.",
          },
        });
      }
      return Promise.resolve(data);
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "An error occurred. Please try again later.";
      dispatch({
        type: LOGIN_FAIL,
        payload: {
          msg: message,
        },
      });
      return Promise.reject(error);
    }
  );
};

export const logoutUser = () => async (dispatch) => {
  dispatch({
    type: LOGOUT_REQUEST,
  });

  try {
    dispatch({
      type: LOGOUT_SUCCESS,
    });
    return Promise.resolve();
  } catch (error) {
    const message =
      (error.response &&
        error.response.data &&
        error.response.data.message) ||
      error.message ||
      "Logout failed. Please try again.";
    dispatch({
      type: LOGOUT_FAIL,
      payload: {
        msg: message,
      },
    });
    return Promise.reject();
  }
};

export const registerUser = (userData) => async (dispatch) => {
  dispatch({
    type: REGISTER_REQUEST,
  });

  return await AuthService.PostUserDetails(userData).then(
    (data) => {
      if (data.data.statusCode === 200) {
        dispatch({
          type: REGISTER_SUCCESS,
          payload: {
            message: "Registration successful! You can now login.",
          },
        });
      } else if (data.data.statusCode === 500) {
        dispatch({
          type: REGISTER_FAIL,
          payload: {
            msg: data.data.result || "Database error. Please try again.",
          },
        });
      } else {
        dispatch({
          type: REGISTER_FAIL,
          payload: {
            msg: data.data.result || "Registration failed. Please try again.",
          },
        });
      }
      return Promise.resolve(data);
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.result) ||
        error.message ||
        "An error occurred. Please try again later.";
      dispatch({
        type: REGISTER_FAIL,
        payload: {
          msg: message,
        },
      });
      return Promise.reject(error);
    }
  );
};

export const fetchUserDetails = (serviceNo) => async (dispatch) => {
  dispatch({
    type: FETCH_USER_REQUEST,
  });

  return await AuthService.GetUserDetailsByUser(serviceNo).then(
    (data) => {
      if (
        data.data.statusCode === 200 &&
        data.data.resultSet &&
        data.data.resultSet.length > 0
      ) {
        const userDetails = data.data.resultSet[0];
        dispatch({
          type: FETCH_USER_SUCCESS,
          payload: userDetails,
        });
      } else {
        dispatch({
          type: FETCH_USER_FAIL,
          payload: {
            msg: "User details not found",
          },
        });
      }
      return Promise.resolve(data);
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.result) ||
        error.message ||
        "Failed to fetch user details.";
      dispatch({
        type: FETCH_USER_FAIL,
        payload: {
          msg: message,
        },
      });
      return Promise.reject(error);
    }
  );
};
